import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import '../AdminLogin/AdminLogin.css';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/apiService';
import bigbucklogo from '../../assets/images/logoo.png';

function AdminLogin() {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!credentials.email || !credentials.password) {
            toast.error('Please enter email and password');
            return;
        }

        try {
            setLoading(true);

            const response = await login(credentials);

            // 🔍 Match EXACT backend structure
            if (response?.success && response?.data?.accessToken) {

                const { user, accessToken, refreshToken } = response.data;

                // ✅ Store in localStorage
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('refreshToken', refreshToken);
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('isLoggedIn', 'true');

                toast.success(response.message || 'Login Successful!');

                setTimeout(() => {
                    navigate('/Dashboard');
                }, 1500);

            } else {
                toast.error(response?.message || 'Invalid credentials');
            }

        } catch (error) {

            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Login failed. Please try again.');
            }

        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <Container className="d-flex vh-100" style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundColor: '#0A0A0A'
        }}>
            <Row className="m-auto align-self-center w-100 position-relative z-2">
                <Col xs={12} md={6} lg={4} className="m-auto">
                    <Form onSubmit={handleSubmit} className="p-4 rounded text-light" style={{ backgroundColor: '#1A1208', border: '1px solid rgba(201,168,76,0.3)', boxShadow: '0 0 30px rgba(201,168,76,0.12)' }}>
                        <div className="text-center mb-3">
                            <img src={bigbucklogo} alt="Crusader Dashboard" style={{ width: '220px', objectFit: 'contain' }} />
                        </div>
                        <h5 className="mb-3 text-center text-light" style={{ fontWeight: 400 }}>
                            Admin Login
                        </h5>

                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={credentials.email}
                                onChange={handleChange}
                                name="email"
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword" className="mt-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={credentials.password}
                                onChange={handleChange}
                                name="password"
                                required
                            />
                        </Form.Group>

                        <Button
                            type="submit"
                            className="mt-3 w-100"
                            disabled={loading}
                            style={{ background: 'linear-gradient(135deg, #C9A84C, #8B6914)', borderColor: '#C9A84C', fontWeight: 600, color: '#0A0A0A' }}
                        >
                            {loading ? 'Logging in...' : 'Login'}
                        </Button>
                    </Form>
                </Col>
            </Row>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Container>
    );
}

export default AdminLogin;
